import { Project } from "@/types/Project.js";
import { BaseEntityService } from "./BaseEntityService.js";
import api from "@/api/index.js";

export class ProjectService extends BaseEntityService<Project> {
	/**
	 * Retrieves a project by id
	 * @param entityId - The id of the project
	 * @returns The project
	 */
	public async getEntity(entityId: string): Promise<Project> {
		const response = await api.getProject(entityId);
		return response;
	}

	/**
	 * Retrieves a project by id and share id
	 * @param entityId - The id of the project
	 * @param shareId - The share id of the project
	 * @returns The project
	 */
	public async getProjectInsecure(entityId: string, shareId: string): Promise<Project> {
		const response = await api.getProjectInsecure(entityId, shareId);
		return response;
	}

	/**
	 * Deletes a project
	 * @param entityId - The id of the project
	 * @returns The deleted project
	 */
	public async deleteEntity(entityId: string): Promise<any> {
		const response = await api.deleteProject(entityId);
		return response;
	}
}
